import { Route, Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth'; // Update this path as needed

const RequirePermission = ({ element: Element, action = 'read', resource, ...rest }) => {
  const { ability } = useAuth();
  
  if (!ability.can(action, resource)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Return a Route component with the conditionally rendered element
  return <Element {...rest} />;
};

export default RequirePermission;